<template>
    <div class="lx-input-wrap" :class="[
      `lx-input-${size}`,
      round ? `lx-input-${size}-round` : '',
      `lx-input${disabled ? '-disabled' : ''}`,
      `lx-input-style-${defaultStyle}`,
    ]" :style="[
      {
        '--width': width,
        '--height': height,
        '--left': isPrefix && defaultStyle === 'first' ? '15px' : 0,
        '--right': isSuffix ? '15px' : 0,
      },
    ]">
        <slot v-if="isPrefix" name="prefix"></slot>
        <input :id="id" class="lx-input lx-flex-grow-1" :type="type" :value="value" :name="name" :src="src" :min="0" :autofocus="autofocus" :maxlength="maxlength" :minlength="minlength" :disabled="disabled" :autocomplete="autocomplete" :placeholder="placeholder" @input="onInput" @blur="onBlur" @change="onChange" @keyup.enter="onKeyup" @paste="onPaste" />
        <slot v-if="isSuffix" name="suffix"></slot>
    </div>
</template>
<script>
export default {
    name: "LxInput",
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        type: {
            type: String,
            default: "text",
            validator: (value) => {
                return [
                    "text",
                    "number",
                    "checkbox",
                    "file",
                    "image",
                    "password",
                    "radio",
                    "submit",
                    "reset",
                    "hidden",
                    "button",
                ].includes(value);
            },
        },
        value: {
            type: [String, Number],
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: "medium",
            validator: (value) => {
                return ["auto", "large", "medium", "small"].includes(value);
            },
        }, // input大小
        defaultStyle: {
            type: String,
            default: "first",
            validator: (value) => {
                return ["first", "second"].includes(value);
            },
        }, // input框样式
        round: {
            type: Boolean,
            default: false,
        }, // 是否圆角
        disabled: {
            type: Boolean,
            default: false,
        }, // 是否禁用
        width: {
            type: String,
            default: "auto",
        },
        height: {
            type: String,
            default: "auto",
        },
        src: {
            type: String,
            default: "auto",
        },
        maxlength: {
            type: Number,
            default: NaN,
        },
        minlength: {
            type: Number,
            default: 0,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        form: {
            type: String,
            default: "",
        },
        isPrefix: {
            type: Boolean,
            default: false,
        }, // 自定义前面的图标
        isSuffix: {
            type: Boolean,
            default: false,
        }, // 自定义后面的图标
    },
    data() {
        return {};
    },
    computed: {
        autocomplete() {
            if (this.type === "text") {
                return "on";
            } else {
                return "off";
            }
        },
    },
    methods: {
        onInput(e) {
            this.$emit("input", e.target.value);
        },
        onBlur(e) {
            this.$emit("blur", e.target.value);
        },
        onChange(e) {
            this.$emit("change", e.target.value);
        },
        onKeyup(e) {
            this.$emit("keyup", e);
        },
        onPaste(e) {
            this.$emit("paste", e);
        },
    },
};
</script>
<style lang="scss" scoped>
.lx-input-wrap {
    flex-grow: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-left: var(--left);
    padding-right: var(--right);
    &.lx-input-auto {
        width: var(--width);
        height: var(--height);
        border-radius: 4px;
        input {
            width: 100%;
        }
    }
    &.lx-input-auto-round {
        border-radius: calc(var(--height) / 2);
    }
    &.lx-input-large {
        height: 54px;
        font-size: 16px;
        border-radius: 8px;
        .lx-input {
            padding: 0 26px;
        }
    }
    &.lx-input-large-round {
        border-radius: 27px;
    }
    &.lx-input-medium {
        height: 40px;
        border-radius: 4px;
    }
    &.lx-input-medium-round {
        border-radius: 20px;
    }
    &.lx-input-small {
        height: 38px;
        border-radius: 3px;
    }
    &.lx-input-small-round {
        border-radius: 19px;
    }
    &.lx-input-style-first {
        border: 1px solid #c3c3c3;
        border-radius: 3px;
        margin: 0;
        box-sizing: border-box;
        padding: 4px 5px;
        background-color: #fff;
        appearance: none;
    }
    &.lx-input-style-second {
        border-radius: 0;
        background-color: #fff;
        border-bottom: 1px solid #e6ebf5;
    }
    .lx-input,
    input {
        height: 100%;
        border: none;
        outline: none;
        font-size: inherit;
        padding: 0 15px;
        background-color: transparent;
        &:-internal-autofill-selected {
            background-color: transparent;
        }
    }
}
</style>
